define('plugin/client-login/view/ClientLoginProfileView',['require','lib/view/FormView','lib/Utils','backbone','plugin/client-login/view/ClientProfileFormBehavior','lib/view/mixin/IntlPhone','Config'],function (require) {

    var FormView = require('lib/view/FormView');
    var Utils = require('lib/Utils');
    var Backbone = require('backbone');
    var ClientProfileFormBehavior = require('plugin/client-login/view/ClientProfileFormBehavior');
    var IntlPhone = require('lib/view/mixin/IntlPhone');
    var Config = require('Config');
    /**
     * Client profile view
     *
     * @class ClientLoginProfileView
     */
    return FormView.extend({

        editTemplate: '#client_login_profile',
        viewTemplate: '#client_login_profile_preview',
        ui: {
            'remind_btn': '#sb_update_btn',
            'inputs': ':input',
            'phoneInput' : ':input[name=phone]',
            'builtInFields': '.sb-built-in-fields',
            'errorFields': '.form-group.has-error'
        },
        triggers: {
            'click @ui.remind_btn': 'update'
        },
        modelEvents: {
            'invalid': 'safeRender',
            'sync': 'checkClientAccess'
        },
        behaviors: function () {
            return {
                ClientProfileFormBehavior: {
                    behaviorClass: ClientProfileFormBehavior,
                    model: this.getOption('model')
                }
            };
        },

        initialize: function () {
            if (!this.getOption('edit')) {
                this.listenTo(this.model, 'sync', this.safeRender);
            }
            FormView.prototype.initialize.apply(this);
        },

        checkClientAccess: function () {
            if (!this.model.get('is_logged_in')) {
                Backbone.history.navigate('', {
                    trigger: true
                });
            }
        },

        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        getTemplate: function () {
            if (this.getOption('edit')) {
                return this.editTemplate;
            }
            return this.viewTemplate;
        },

        getProfileData: function () {
            var data = this._getData(this.ui.inputs);
            if (this.getOption('edit') && data.phone) {
                data.phone = Utils.getClientPhoneValue(data.phone);
            }

            return data;
        },

        serializeData: function () {
            var res = this._serializeData();

            _.extend(res, this.getOption('externalData'));

            if (this.getOption('edit')) {
           /*     var phoneData = Utils.getClientPhoneData(res.data.phone);
                _.extend(res.data, phoneData, {
                    'phone': phoneData.client_phone
                });*/
                _.extend(res.data, {
                    'phone': Utils.getClientPhoneValue(
                        res.data.phone
                    )
                });
            }
            return _.extend({
                'is_modal': this.getOption('isModal')
            }, res);
        },

        destroy: function () {
            if (this.getOption('edit') && this.model.validationError) {
                this.model.fetch();
                this.model.validationError = null;
            }
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'client_profile'
            });
            
            if (this.ui.builtInFields.is(':visible')) {
                if (this.ui.errorFields.length) {
                    this.ui.errorFields[0].scrollIntoView();
                }
            } 
        },

        onRender: function () {
            var config = Config.getInstance();
            IntlPhone.showIntlPhone(this.ui.phoneInput, {
                //required : false,
                nationalMode: true,
                countryPrefix: config.getOption('country_prefix'),
                countryPrefixId: config.getOption('country_prefix_id'),
                allowedPrefix: config.getOption('country_prefix_is_changeable')?null:config.getOption('country_prefix'),
            });
            
            Backbone.Wreqr.radio.vent.trigger('page', 'render', {
                'page': 'client_profile',
                'view': this
            });
        },
        
        hideBuiltInFields: function () {
            this.ui.builtInFields.hide();
        }

    });

});
